// extracted by mini-css-extract-plugin
export default {"reason":"table-content_reason__enQ8q","link":"table-content_link__UKSlT","loader":"table-content_loader__H4OCk"};